import { SHOW_ALERT, DISMISS_ALERT, SHOW_NOTIFICATION, DISMISS_NOTIFICATION } from '../actionTypes'
import { notificationTime } from 'variables'
import i18n from 'i18n'

export const confirm = (translationKey, action, translationValues = {}) =>
  showAlert(
    i18n.t(`${translationKey}.title`, translationValues),
    i18n.t(`${translationKey}.message`, translationValues),
    i18n.t(`${translationKey}.cancel`, translationValues),
    [{ label: i18n.t(`${translationKey}.confirm`, translationValues), action }]
  )

export const showAlert = (
  title,
  message,
  dismiss = i18n.t('alert.ok'),
  actions
) => ({
  type: SHOW_ALERT,
  payload: { type: 'alert', title, message, actions, dismiss }
})
export const showNotification = (message, actions) => dispatch => {
  const id = new Date().valueOf()
  setTimeout(() => dispatch(dismissNotification(id)), notificationTime * 1000)
  return dispatch({
    type: SHOW_NOTIFICATION,
    payload: { type: 'notification', id, message, actions }
  })
}
export const dismissAlert = () => ({
  type: DISMISS_ALERT
})

export const dismissNotification = id => ({
  type: DISMISS_NOTIFICATION,
  payload: { id }
})

export const alertReducer = (
  state = { alert: null, notifications: [] },
  { type, payload }
) => {
  switch (type) {
    case SHOW_ALERT:
    return { ...state, alert: payload }
    case SHOW_NOTIFICATION:
      return { ...state, notifications: [...state.notifications, payload] }
    case DISMISS_ALERT:
      return { ...state, alert: null }
    case DISMISS_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(n => n.id !== payload.id)
      }
    default:
      return state
  }
}
